// extracted by mini-css-extract-plugin
export default {"root":"N5G7C","descriptionHidden":"tkXSU","descriptionToggle":"HVPqB"};